import React, { Component } from 'react'
import { Link, HashRouter } from 'react-router-dom'
import { setRegPage, currentWidget, popupOpenClose, setMobileTVPage, setDeviceConfigFailed, setFailScreen, openSMSWidget, setOpenProfileImage } from '../../action/action'
import { connect } from 'react-redux'
import { setRoomControlPage } from '../../layout2.0/action/action'
import { nonCompWidgetClick } from '../../layout2.0/JS/widgetHandling'
import { setExternalSignIn, setLoginRequired, setOpenDemoCamera } from '../../layout2.0/action/homeAction'
import { closeOrderPopUp } from '../../layout2.0/action/hCommerce2'
import { setHcommerceWidget } from '../../layout2.0/action/hCommerce2';
import { setDNDon, setMURon, setGoHome, setLoader } from '../../layout2.0/action/homeAction';
import {sendAcCommand} from '../../action/roomControlAction'
import { guestDetails, sendAnalytics } from '../../action/homeAction'
import { withTranslation } from 'react-i18next'
import { setOpenExternalLinkInSameTab } from '../../layout2.0/action/homeAction'

class HorizontalDoubleLargeWidget extends Component {

    setRoomControlPageOnClick = (widget) => {
        switch (widget.widgetType) {
            case "Room Theme":
                this.props.setRoomControlPage("roomTheme");
                break;
            case "Room Temperature":
                this.props.setRoomControlPage("AcControl");
                break;
            case "Speaker":
                this.props.setRoomControlPage("speakerControl");
                break;
            case "Smart Window Control":
                this.props.setRoomControlPage("windowTintControl");
                break;
            default:
                console.log("no room control path is matching.")
                break;
        }
    }
    onWidgetClick = async (widget) => {
        let room = localStorage.getItem('room')
        console.log("current widget", widget)
        if (widget.path) {
            await this.props.currentWidget(widget);
            if (widget.path === "/RoomControl2") {
                this.setRoomControlPageOnClick(widget);
            }
            if (widget.path === "/mobileTv") {
                if(!room){
                    if(process.env.REACT_APP_INROOMTAB == "true") {
                        this.props.setLoginRequired(true)
                    } else {
                        this.props.setRegPage(true);
                    }
                } else {
                    this.props.setMobileTVPage(true);
                }
            }
            if (widget.widgetType === "Hcommerce") {
                this.props.setHcommerceWidget(widget);
            }
            if (widget.path === "/happy") {
                if(this.props.survey.needsLogin)
                if(!room || room === "null"){
                    if(process.env.REACT_APP_INROOMTAB == "true") {
                        this.props.setLoginRequired(true)
                    } else {
                        this.props.setRegPage(true);
                    }
                }
            }
        } else {
            nonCompWidgetClick(widget, this.props)
        }
    }

    render() {
        return (
            <div class="row">
                <div class="col col-2 flex-nowrap">
                    {this.props.widgetList.length > 0 ?
                        this.props.widgetList.map((iterator) => {
                            return (
                                <Link id={iterator.widgetType} className={ !iterator.widgetType === 'MUR' && !iterator.widgetType === 'DND' 
                                                                            ? 'tile-sm thumbnails tile-container'
                                                                            : iterator.widgetType === 'MUR' 
                                                                                ? this.props.MUR
                                                                                    ? 'tile-sm thumbnails tile-container active' 
                                                                                    :'tile-sm thumbnails tile-container'
                                                                                : iterator.widgetType === 'DND' 
                                                                                    ? this.props.DND
                                                                                        ? 'tile-sm thumbnails tile-container active' 
                                                                                        :'tile-sm thumbnails tile-container'
                                                                                    :'tile-sm thumbnails tile-container'}
                                    onClick={() => { this.onWidgetClick(iterator) }}
                                    exact to={iterator.path ? iterator.path : "/"}
                                >
                                    <div class="thumb-img">
                                        {iterator.compImage ?
                                            <img src={iterator.compImage}></img> :
                                            ""
                                        }
                                        {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 139.8 249.1"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M28.18,219.1H25.32v9.75h2.83A4.67,4.67,0,0,0,33,224,4.55,4.55,0,0,0,28.18,219.1Z" /><path class="cls-1" d="M54.55,150.89c0-8.07-5-14.34-14.34-14.34H31.79V165.3h8.35C49.24,165.3,54.55,158.75,54.55,150.89Z" /><path class="cls-1" d="M63,194.87c0,6,3.84,10.64,9.87,10.64s9.82-4.61,9.82-10.64-3.84-10.65-9.82-10.65S63,188.79,63,194.87Z" /><path class="cls-1" d="M96.58,219.1H93.07v4.21h3.51a2.11,2.11,0,1,0,0-4.21Z" /><path class="cls-1" d="M112.42,225.29h-4.3v3.56h4.3c1.24,0,2-.65,2-1.78A1.78,1.78,0,0,0,112.42,225.29Z" /><path class="cls-1" d="M93.36,135.86c-8.55,0-14,6.48-14,15.1s5.44,15.1,14,15.1,13.93-6.55,13.93-15.1S101.84,135.86,93.36,135.86Z" /><path class="cls-1" d="M114.1,220.73a1.63,1.63,0,0,0-1.82-1.63h-4.16v3.27h4.16A1.61,1.61,0,0,0,114.1,220.73Z" /><path class="cls-1" d="M69.9,0h0A69.91,69.91,0,0,0,0,69.9v165A14.17,14.17,0,0,0,14.17,249.1H125.63a14.16,14.16,0,0,0,14.17-14.17V69.9A69.9,69.9,0,0,0,69.9,0ZM91.47,184.71v-6.08h25.86v6.08H107.9v26.34h-7V184.71Zm1.89-10c-13.92,0-24.06-9.93-24.06-23.79s10.14-23.79,24.06-23.79,24,9.93,24,23.79S107.22,174.75,93.36,174.75Zm-3.6,20.12c0,9.77-7.14,16.77-16.91,16.77s-17-7-17-16.77,7.15-16.77,17-16.77S89.76,185.1,89.76,194.87ZM69.9,25.48A41.81,41.81,0,1,1,28.09,67.29,41.81,41.81,0,0,1,69.9,25.48ZM22,127.93H40.14c14.41,0,24.4,9.17,24.4,23s-10,23-24.33,23H22Zm0,50.7h7.1l15,20.37V178.63H51v32.42H44.36L28.91,189.91v21.14H22Zm6.18,53.14H22v-15.6h6.15c4.89,0,8.28,3.11,8.28,7.79S33,231.77,28.18,231.77Zm14,0H38.8v-15.6h3.33Zm8.65.28a9,9,0,0,1-6.64-2.48L46,227a6.86,6.86,0,0,0,5,2.13c1.85,0,2.72-.82,2.72-1.73,0-2.72-9-.82-9-6.69,0-2.6,2.24-4.75,5.91-4.75a8.66,8.66,0,0,1,6.08,2.18l-1.84,2.47a6.71,6.71,0,0,0-4.54-1.7c-1.4,0-2.2.6-2.2,1.54,0,2.46,9,.8,9,6.62C57,229.9,55,232.05,50.78,232.05Zm19.66-13H65.9v12.67H62.56V219.1H58v-2.93H70.44Zm16.21,6.43c0,3.86-2.29,6.52-7,6.52s-7-2.66-7-6.52v-9.36h3.37v9.27a3.66,3.66,0,1,0,7.32,0v-9.27h3.39Zm11.92,6.24-3.07-5.54H93.07v5.54H89.75v-15.6h7.3a4.88,4.88,0,0,1,5.26,5,4.51,4.51,0,0,1-3.44,4.63l3.53,5.94Zm14.69,0H104.8v-15.6H113c3,0,4.5,1.9,4.5,4a3.49,3.49,0,0,1-2.69,3.58,3.75,3.75,0,0,1,3,3.81C117.8,229.9,116.26,231.77,113.26,231.77Z" /></g></g></svg> */}
                                    </div>
                                    <div class="thumb-text" >
                                        <p class="thumb-heading" dangerouslySetInnerHTML={{__html: iterator.widgetTitle ? iterator.widgetTitle : ""}} ></p>
                                        <p dangerouslySetInnerHTML={{__html: iterator.widgetDesc ? iterator.widgetDesc : ""}} ></p>
                                    </div>
                                </Link>
                            )
                        }) : ""
                    }
                </div>
            </div >
        )
    }
}

HorizontalDoubleLargeWidget.defaultProps = {
    widgetList: []
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        appLauncherWidget: state.store.appLauncher.widget,
        DND: state.store.InncomRoomControl.DND?
        state.store.InncomRoomControl.DND: null,
        MUR: state.store.InncomRoomControl.MUR?
        state.store.InncomRoomControl.MUR: null,
        streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
            state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
        menuColor: state.store.home.MenuColor,
        currentHomePage: state.store2.currentHomePage,
        survey: state.store.survey,
        externalSignIn: state.store2.externalSignIn,
        roomControlSpecificVersion: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.roomControlSpecificVersion,

    }
}
export default connect(
    mapStateToProps,
    {
        currentWidget,
        popupOpenClose,
        openSMSWidget,
        setOpenProfileImage,
        setRoomControlPage,
        setDeviceConfigFailed,
        setOpenDemoCamera,
        setRegPage,
        closeOrderPopUp,
        setHcommerceWidget,
        setDNDon,
        setMURon,
        setMobileTVPage,
        sendAcCommand,
        sendAnalytics,
        setGoHome,
        setLoader,
        setFailScreen,
        setLoginRequired,
        guestDetails
        ,setOpenExternalLinkInSameTab,
        setExternalSignIn
    }
    )(withTranslation('translations')(HorizontalDoubleLargeWidget));